import React, { FunctionComponent, useContext, useEffect, useState } from 'react'
import FormField from '@components/FormField/FormField'
import { IntegerProps } from '../AnswerProps'
import './IntegerInput.scss'
import { SurveyContext } from '@context/SurveyContext'
import { SurveyMode } from '@reducers/SurveyReducer'
import Button from '@components/Button/Button'
import { useTranslation } from 'react-i18next'

export const IntegerInput: FunctionComponent<IntegerProps> = ({ question, onSelection, answer }: IntegerProps) => {
  const { i18n } = useTranslation()
  const currentLocale = (i18n.language ?? 'fr').substring(0, 2)
  const prefix = currentLocale === 'fr' ? question.meta.prefixFr : question.meta.prefixEn
  const suffix = currentLocale === 'fr' ? question.meta.suffixFr : question.meta.suffixEn
  const min =
    question.meta.minimum ?? question.meta.min ?? undefined
  const max =
    question.meta.maximum ?? question.meta.max ?? undefined

  let timer: ReturnType<typeof setTimeout>
  const { t } = useTranslation('Buttons')
  const {
    mode,
  } = useContext(SurveyContext)

  const [cachedValue, setCachedValue] = useState('')

  useEffect(() => {
    setCachedValue(answer as string)
  }, [answer]);

  const inputHandler = (value: string) => {
    // debounce
    if (value === '') return

    if ([SurveyMode.SANDBOX, SurveyMode.SANDBOX_PORTRAIT].includes(mode)) {
      setCachedValue(value);
      return;
    }

    clearTimeout(timer)
    timer = setTimeout(() => {
      onSelection(parseInt(value))
    }, 400)
  }

  const handleUpdate = () => {
    onSelection(parseInt(cachedValue))
  }

  return (
    <div className="IntegerInput">
      <div className="TxtContainer">
        <div className="Prefix">{prefix}</div>
        <FormField
          type="number"
          id={question.key}
          min={min}
          max={max}
          placeholder={question.hint}
          onChange={inputHandler}
          value={`${answer?.toString()}`}
        />
        <div className="Suffix">{suffix}</div>
      </div>
      {[SurveyMode.SANDBOX, SurveyMode.SANDBOX_PORTRAIT].includes(mode) && (
        <Button onClick={handleUpdate} disabled={cachedValue === answer}>
          {t('update')}
        </Button>
      )}
    </div>
  )
}

export default IntegerInput
